// TypingLine.js
import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import { styled, keyframes } from '@mui/system';

const blink = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0; }
`;

const Cursor = styled('span')({
  display: 'inline-block',
  width: '10px',
  height: '1em',
  backgroundColor: '#C77DFF',
  marginLeft: '4px',
  animation: `${blink} 1s step-start infinite`,
});

const TypingLine = ({ text, delay = 30, onDone, showCursor = true, isError = false }) => {
  const [displayedText, setDisplayedText] = useState('');
  const [done, setDone] = useState(false);

  useEffect(() => {
    let i = 0;
    const interval = setInterval(() => {
      setDisplayedText(text.slice(0, i + 1));
      i++;
      if (i >= text.length) {
        clearInterval(interval);
        setDone(true);
        if (onDone) onDone();
      }
    }, delay);
    return () => clearInterval(interval);
  }, [text]);

  return (
    <Typography variant="body1" sx={{ whiteSpace: 'pre',  color:isError?'#FF5C5C': '#C77DFF'}}>
      {displayedText}
      {showCursor && !done && <Cursor />}
    </Typography>
  );
};

export default TypingLine;
